import { useEffect } from 'react'
import { Paper, Box } from '@mui/material'
import { useSelector } from 'react-redux'

import { ApplicationState } from '@/state/root.models'
import BalanceReportFilters from './components/filters/index.component'
import BalanceReportTable from './components/table/index.component'

import useBalanceReportActions from './hooks/use-balance-report-actions.hooks'
import useBalanceReportFilters from './hooks/use-balance-report-filters.hooks'

const BalanceReportModule = () => {
  const { resetBalanceReport, setBalanceReportFilters } =
    useBalanceReportActions()

  const { submitSearchFilter } = useBalanceReportFilters()

  const { brand } = useSelector(({ auth }: ApplicationState) => auth)

  // Load (and reload on brand switch) the balance list scoped to the brand.
  useEffect(() => {
    submitSearchFilter()
    // eslint-disable-next-line
  }, [brand.siteId])

  useEffect(() => {
    return () => {
      setBalanceReportFilters({
        playerId: '',
        startDate: '',
        endDate: '',
        page: 1,
        limit: 25,
      })
      resetBalanceReport()
    }
    // eslint-disable-next-line
  }, [])

  return (
    <Box component={Paper} p={2} display="flex" flexDirection="column">
      <BalanceReportFilters />
      <BalanceReportTable />
    </Box>
  )
}

export default BalanceReportModule
